import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IPrecatorio } from "../interfaces/IPrecatorio";
import { IDapPrecatorioResponse } from "../interfaces/IDapPrecatorioResponse";
import { IPrecatorioCreateOrUpdateOfficerDto } from "../interfaces/IPrecatorioCreateNew";

enum PrecatorioServiceEnum {
  getAll = "/get-all-from-officer",
  putUploadProcessDocument = "/upload-process-document",
  postFindDap = "/find-dap",
  getAllOperator = "/get-all-officer-operator",
  getById = "/"
}
export default class PrecatorioService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/precatorio");
  }
  public getAll = async () => await this.GET(PrecatorioServiceEnum.getAll);
  public getById = async (precatorioId: number): Promise<IPrecatorioCreateOrUpdateOfficerDto> => await this.GET(PrecatorioServiceEnum.getById + precatorioId);
  public putUploadProcessDocument = async document => await this.PUT(PrecatorioServiceEnum.putUploadProcessDocument, document);
  public postFindDap = async (data): Promise<IDapPrecatorioResponse> => await this.POST(PrecatorioServiceEnum.postFindDap, data);
  public getAllOperator = async (): Promise<IPrecatorio[]> => await this.GET(PrecatorioServiceEnum.getAllOperator);
}



// WEBPACK FOOTER //
// ./src/services/api/Precatorio.service.ts